"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePicker = void 0;
const UiKitLite_1 = require("../UiKitLite");
const react_1 = __importStar(require("react"));
const react_2 = require("@chakra-ui/react");
const DatePicker = () => {
    const [birthday, setBirthday] = (0, react_1.useState)(new Date());
    const [dateAndTime, setDateAndTime] = (0, react_1.useState)(new Date());
    const [customFormatDate, setCustomFormatDate] = (0, react_1.useState)(new Date());
    return (react_1.default.createElement(react_2.VStack, { align: 'stretch', spacing: '20px' },
        react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Label, { label: 'Birthday' },
            react_1.default.createElement(react_2.HStack, { align: 'center' },
                react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Date, { selected: birthday, onChange: setBirthday }))),
        react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Label, { label: 'Date and Time' },
            react_1.default.createElement(react_2.HStack, { align: 'center' },
                react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Date, { selected: dateAndTime, onChange: setDateAndTime, showTimeSelect: true }))),
        react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Label, { label: 'Custom Format Displayed (yyyy)' },
            react_1.default.createElement(react_2.HStack, { align: 'center' },
                react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Date, { selected: customFormatDate, onChange: setCustomFormatDate, dateFormat: 'yyyy' }))),
        react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Label, { label: 'Custom Formats yyyy-MM-dd, yyyy/MM/dd, yyy-MM-dd HH:mm:ss etc' },
            react_1.default.createElement(react_2.HStack, { align: 'center' },
                react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Date, { selected: customFormatDate, onChange: setCustomFormatDate, dateFormat: 'yyyy-MM-dd' }),
                react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Date, { selected: customFormatDate, onChange: setCustomFormatDate, dateFormat: 'yyyy/MM/dd' }),
                react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Date, { selected: customFormatDate, onChange: setCustomFormatDate, dateFormat: 'yyyy-MM-dd HH:mm:ss', showTimeSelect: true }))),
        react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Label, { label: 'Disabled Date Picker' },
            react_1.default.createElement(react_2.HStack, { align: 'center' },
                react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Date, { selected: customFormatDate, onChange: setCustomFormatDate, dateFormat: 'yyyy-MM-dd', readOnly: true })))));
};
exports.DatePicker = DatePicker;
